export default {
    IN_CHARGE: 1,
    PAID: 2,
    EXPIRED: 3,
};
